// @flow
import Head from 'next/head';
import React from 'react';

import { useAbTasty } from 'Components/utils/ab-tasty/abTasty.utils';

export const AbTasty = () => {
  const { abTastyScriptUrl, isAbTastyActive } = useAbTasty();

  return isAbTastyActive ? (
    <Head>
      <script key="abtasty-lib" src={abTastyScriptUrl} />
      <script
        key="abtasty-inline-script"
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{
          __html: `
              document.addEventListener('cm_app_mounting', function () {
                if (window.ABTasty && window.ABTasty.rollbackModifications) {
                  window.ABTasty.rollbackModifications();
                }
              });
              document.addEventListener('cm_app_mounted', function () {
                if (window.ABTasty && window.ABTasty.applyModifications) {
                  window.ABTasty.applyModifications();
                }
              });
            `,
        }}
      />
    </Head>
  ) : null;
};
